// src/user.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ADMIN"] = "admin";
  UserRole2["JOURNALIST"] = "journalist";
  return UserRole2;
})(UserRole || {});
var getMe = (client) => async (options) => {
  return await client.get("users/me", options).json();
};
var createUserApi = (client) => {
  return {
    getMe: getMe(client)
  };
};

export {
  UserRole,
  createUserApi
};
